module.exports = __webpack_public_path__ + "assets/videos/video-banner-desktop.mp4?v=0064b743";